import { content } from './template';
import { htmlToElement } from '../../common/dom';

export const render = (payments) => {
  const dropContent = document.querySelector('.schedule-payments-modal-content');
  while (dropContent.firstChild) {
    dropContent.removeChild(dropContent.firstChild);
  }
  const html = content(payments);
  dropContent.appendChild(htmlToElement(html));
};
